import { GtmHelper as GtmHelperCore } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { flowManager } from '@flows';

const mapping: Record<string, string> = {};
let isMapped = false;

const getScreenNameFromUrl = (): string => {
	const url = window.location.href;

	const stepName = url.substr(url.indexOf('step=') + 'step='.length);
	let screenName = mapping[stepName];

	if (!isMapped) {
		/**
		 * fill mapping dictionary only 1 time using all gtm data definitions
		 */
		for (const moduleKey of Object.keys(GtmValues)) {
			const module = (GtmValues as any)[moduleKey];

			for (const screenKey of Object.keys(module)) {
				const screen = module[screenKey];

				const urlMatchForScreenName = screen['urlMatchForScreenName'];
				const innerScreenName = screen['screenName'];

				mapping[urlMatchForScreenName] = innerScreenName;

				screenName = urlMatchForScreenName === stepName ? innerScreenName : screenName;
			}
		}

		isMapped = true;
	}

	return screenName;
};

// cSpell: disable
export const GtmValues = {
	general: {
		simulator: GtmHelperCore.createScreenData({
			actions: {},
			screenName: 'perfil/simulator',
			urlMatchForScreenName: flowManager.screens.simulator.name,
		}),
	},
	modals: {
		close: GtmHelperCore.createScreenData({
			actions: {
				exit: {
					eName: 'sair_fluxo',
				},
				confirm: {
					eName: 'confirmar_sair',
				},
				cancel: {
					eName: 'cancelar_sair',
				},
			},
			screenName: (): string => getScreenNameFromUrl(),
		}),
	},
};
// cSpell: enable
